import angular from 'angular';

import { CONSTANTS } from 'config';

import template from './tsz-price-calculator.html';
import './tsz-price-calculator.styl';

import calculatorTpl from './modals/calculator.html';

function controller($mdDialog) {

  'ngInject';

  this.showCalculator = (ev) => {

    $mdDialog.show({
      controller: ($scope, ReportService) => {

        $scope.loading = false;

        $scope.BUILDING_USAGE = CONSTANTS.BUILDING_USAGE;
        $scope.PROJECT_TYPE = CONSTANTS.PROJECT_TYPE;

        $scope.report = {};
        $scope.price = 0;

        $scope.close = () => {
          $mdDialog.hide();
        };

        $scope.refreshPricing = () => {
          if ($scope.report.building_usage && $scope.report.design_type && $scope.report.area) {
            $scope.loading = true;
            ReportService.getBasePrice($scope.report)
            .then((response) => {
              $scope.price = response.price.toFixed(2);
            }).catch(() => {
              console.log('Error calculating report price');
            }).finally(() => {
              $scope.loading = false;
            });
          }
        };
      },
      template: calculatorTpl,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

}

export default {
  template,
  bindings: {
    companyId: '<',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-price-calculator/tsz-price-calculator.js